<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="d-flex justify-content-center mt-50 mb-5">
          <div>
            <div style="position: relative;">
              <v-badge
                bordered
                left
                :content="`${quantity_items_cart}`"
                color="accent"
                offset-x="10"
                offset-y="10"
                class="badge-bolsa"
              >
                <img
                  class="cart-image-bolsa"
                  src="@/assets/store/iconos/bolsa.svg"
                >
              </v-badge>
              <div class="div-title-cart font-backward">
                {{ is_auth ? `¡Hola ${user.name}` : `Tu compra` }}!
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-none d-sm-none d-md-block">
      <div class="col">
        <v-card color="light" elevation="0" class="p-3">
          <div v-if="cart.cart_products.length > 0">
            <div class="container">
              <div class="row">
                <div class="col">
                  <table class="table">
                    <thead>
                      <tr>
                        <th style="width: 150px"></th>
                        <th style="width: 200px" class="color-blue font-general-r">PRODUCTO</th>
                        <th style="width: 100px" class="color-blue font-general-r">PRECIO</th>
                        <th style="width: 100px; text-align: center" class="color-blue font-general-r">CANTIDAD</th>
                        <th style="width: 100px; text-align: center" class="color-blue font-general-r">TOTAL</th>
                        <th style="width: 100px; text-align: center" class="color-blue font-general-r">QUITAR</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ItemCart v-for="item in cart.cart_products" :key="item.id" :item="item"></ItemCart>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="border-nv mb-10 mt-5"></div>

              <div class="row color-blue font-general-r">
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
                  <h5>
                    {{ cart.cart_products.length }} {{ cart.cart_products.length > 1 ? 'productos' : 'producto' }} en tu bolsa
                  </h5>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 d-flex justify-content-end">
                  <h5 class="mr-5">SUBTOTAL:</h5>
                  <h5>{{ currencyFormat(cart_total) }}</h5>
                </div>
              </div>
              <div class="row" v-if="select_discount">
                <div class="col d-flex justify-content-end color-blue font-general-r ">
                  <h5 class="mr-5">
                    <b>{{ select_discount.code }}:</b>
                  </h5>
                  <h5>
                    {{ select_discount && select_discount.type != 'shipping_free' ? currencyFormat(amount_discount) : 'ENVÍO GRATIS' }}
                  </h5>
                </div>
              </div>
              <div class="row color-blue font-general-r">
                <div class="col d-flex justify-content-end">
                  <h5 class="mr-5">TOTAL:</h5>
                  <h5>{{ currencyFormat(total_cart) }}</h5>
                </div>
              </div>

              <div class="row">
                <div class="col">
                  <div class="text-right mt-10 d-flex justify-content-end">
                    <v-btn
                      :loading="loading_btn_clean_cart"
                      @click="cleanCart()"
                      color="accent"
                      class="nv-btn nv-btn-large mb-2 mr-8"
                      elevation="0"
                    >
                      VACIAR CARRITO
                    </v-btn>
                    <v-btn
                      @click="continueBuy()"
                      color="secondary"
                      class="nv-btn nv-btn-large mb-2 mr-8"
                      elevation="0"
                    >
                      SEGUIR COMPRANDO
                    </v-btn>
                    <v-btn
                      @click="checkout()"
                      color="primary"
                      class="nv-btn nv-btn-hover nv-btn-large"
                      elevation="0"
                    >
                      FINALIZAR PEDIDO
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </v-card>
      </div>
    </div>

    <div v-if="cart.cart_products.length" class="d-block d-sm-block d-md-none">
      <div class="text-center">
        <v-btn
          :loading="loading_btn_clean_cart"
          @click="cleanCart()"
          color="accent"
          class="nv-btn nv-btn-large pa-5 mb-2"
          elevation="0"
        >
          VACIAR CARRITO
        </v-btn>
      </div>

      <!--esto se muestra en moviles-->
      <div class="row" v-for="item in cart.cart_products" :key="item.id">
        <div class="col-sm-5 col-xs-5 col-5">
          <img
            :src="item.product.url_image_flask"
            :alt="item.product.name"
            class="img-product-cart"
          />
        </div>
        <div class="col-sm-7 col-xs-7 col-7 d-flex justify-space-between align-items-center">
          <div>
            <p class="h5 mt-2 color-blue font-general-l">
              {{ item.product.name }} x {{ item.quantity }}
            </p>
            <span class="h5 color-blue font-general-l">{{ item.option_size }}</span>
            <p class="h5 color-blue font-general-l">
              {{
                currencyFormat(item.subtotal)
              }}
            </p>
          </div>
          <div>
            <v-btn
              v-if="item.hasOwnProperty('id')"
              color="accent"
              text
              :loading="loading_btn_remove_cart"
              @click="removeItemCart(item.id)"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-btn
              v-else
              color="accent"
              text
              :loading="loading_btn_remove_cart"
              @click="removeItemCart(item.product.id)"
            >
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col color-blue font-general-r">
          <div class="border-nv mb-10 mt-10"></div>
          <h5>
            {{ cart.cart_products.length }} {{ cart.cart_products.length > 1 ? 'productos' : 'producto' }} en tu bolsa
          </h5>
          <h5>SUBTOTAL: {{ currencyFormat(total_cart) }}</h5>
          <div class="text-right">
            <v-btn
              @click="continueBuy()"
              color="secondary"
              class="nv-btn nv-btn-large pa-5"
              elevation="0"
            >
              SEGUIR COMPRANDO
            </v-btn>
            <v-btn
              @click="checkout()"
              color="primary"
              class="nv-btn nv-btn-hover nv-btn-large pa-5"
              elevation="0"
            >
              FINALIZAR PEDIDO
            </v-btn>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!cart.cart_products.length">
      <p class="text-center m-0 pb-5 h3 color-blue font-general-r">Tu carrito esta vacio.</p>
    </div>

    <div v-if="cart.cart_products.length" class="row">
      <div class="col">

        <div style="width: 95%" class="m-auto">
          <p class="center-content-sm color-blue font-general-r h4">¿QUÉ TAL UN SABOR MÁS?</p>

          <!--solo en moviles-->
          <v-sheet
            class="mx-auto d-block d-sm-block d-md-none"
            max-width="1800"
          >
            <v-slide-group
              show-arrows
              max="4"
            >
              <v-slide-item
                v-for="(item, index) in flavors"
                :key="index"
                v-slot="{ active }"
                class="slide-item-flavor"
              >
                <ItemSlideFlavor @addCart="added_cart = true" :active="active" :item="item"></ItemSlideFlavor>
              </v-slide-item>
            </v-slide-group>
          </v-sheet>

          <div class="d-none d-sm-none d-md-block ">
            <div class="row mt-50" :key="flavors.length" v-if="flavors.length">
              <div
                class="flavor_list col-lg-4 col-md-6 col-sm-12 col-xs-12 mb-50"
                v-for="(item, index) in flavors"
                :key="index"
              >
                <ItemSlideFlavor @addCart="openSnackCart" :active="false" :item="item"></ItemSlideFlavor>
              </div>
            </div>
          </div>

        </div>

      </div>
    </div>

    <SnackbarCart ref="snackbarCart"/>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { currencyFormat } from '@/helpers'
//import HomeService from '@/services/home.service'
import ItemCart from '@/components/store/ItemCart'
import ItemSlideFlavor from '@/components/store/ItemSlideFlavor'

export default {
  props: ['flavors'],
  components: {
    ItemCart,
    ItemSlideFlavor
  },
  data: () => ({
    added_cart: false,
    loading_btn_remove_cart: false,
    loading_btn_clean_cart: false
  }),
  computed: {
    ...mapState(['cart', 'is_auth', 'user', 'select_discount', 'amount_discount', 'cart_total']),
    ...mapGetters(['total_cart', 'quantity_items_cart'])
  },
  watch: {
    open_cart(newval) {
      if (newval) {
        this.refreshFlavorArray()
      }
    }
  },
  methods: {
    openSnackCart() {
      this.$refs.snackbarCart.open()
    },
    removeItemCart(item_id) {
			try {
        this.loading_btn_remove_cart = true
        setTimeout(() => {
          this.$store.dispatch('removeItemCart', { id: item_id })
          this.loading_btn_remove_cart = false
        }, 500)
			} catch (error) {
				this.$notify({
					group: 'admin',
					title: 'Ocurrio un problema: '.error.message,
					type: 'success',
				})
			}
		},
    checkout() {
      this.$emit('closeModal')
      this.$router.push({path: '/procesar-pago', query: { step: 'direccion-envio' }})
    },
    async cleanCart() {
      this.loading_btn_clean_cart = true
      await this.$store.dispatch('cleanCart')
      this.loading_btn_clean_cart = false
		},
    refreshFlavorArray() {
      let flavors_cart_id = this.cart.cart_products.map(i => {
        return i.product.id
      })
      this.data_home_page.flavors.forEach(i => {
        if (!flavors_cart_id.includes(i.id)) {
          this.flavors.push(i)
        }
      })
    },
    pushFlavor(flavor) {
      this.open_cart = false
      location.href = `/helado-sabor/${flavor.slug}/${flavor.id}`
    },
    continueBuy() {

      let route = this.$route.name
      this.$emit('closeModal')
			if (route != 'Home') {
        this.$router.push({path: '/', hash: '#sabores'})
			} else {
				const offsetTop = document.querySelector('#sabores').offsetTop;
				scroll({
					top: offsetTop,
					behavior: "auto"
				});
			}

      //this.$router.push({path: '/', hash: 'sabores'})
      /*const offsetTop = document.querySelector().offsetTop;
      scroll({
        top: offsetTop + sum,
        behavior: "auto"
      });*/
    },
    currencyFormat(price) {
			return currencyFormat(price)
		}
  }
}
</script>

<style scoped>
  .image-flavor-cart {
    cursor: pointer;
  }
  .table th {
    color: var(--color-tertiary);
    font-family: var(--font-baloo-regular)
  }
  .table {
    border-collapse: collapse !important;
    border-spacing: 0px;
    table-layout: fixed;
  }
  th {
    border: none !important;
    font-size: 16px;
  }
  tr {
    border: none !important;
  }
  th, td {
    word-wrap: break-word;
  }
  >>>.table td, .table th {
    border-top: 0 !important
  }
  @media only screen and (min-width: 1520px) and (max-width: 3000px) {
    >>>.v-snack__content {
      padding: 36px 40px !important;
    }
  }
</style>
